/**
 * TanStack Router: /recruitment
 *
 * This route file was auto-generated by the route generation script.
 * Component: RecruitmentPage
 * Layout: Authenticated (_auth)
 *
 * @see scripts/generate-routes.ts
 * @see docs/architecture/tanstack-router-migration-architecture.md
 */
import { createFileRoute } from '@tanstack/react-router'
import RecruitmentPage from '@/app/recruitment/page'

/**
 * Route: /recruitment
 * Layout: _auth (authenticated)
 * Component: RecruitmentPage
 */
export const Route = createFileRoute('/_auth/recruitment/')({
  component: RecruitmentPage,
})
